<template>
  <flow-part :id="$options.name">
    <template #heading>
      <h2>Persoonsgegevens</h2>
    </template>
    <template #content>
      <field-label
        text="Geslacht"
      />
      <section class="gender-field-group">
        <section
          id="customer_gender"
          class="radio-group scroll-offset"
        >
          <big-radio-input
            id="gender-m"
            v-model="orderStore.customer_gender"
            title="Man"
            value="M"
            @input="orderStore.errors.customer_gender = null"
          />
          <big-radio-input
            id="gender-f"
            v-model="orderStore.customer_gender"
            title="Vrouw"
            value="F"
            @input="orderStore.errors.customer_gender = null"
          />
          <big-radio-input
            id="gender-x"
            v-model="orderStore.customer_gender"
            title="Anders"
            value="X"
            @input="orderStore.errors.customer_gender = null"
          />
        </section>
        <section class="radio-group-error">
          <field-error
            :error="orderStore.errors.customer_gender"
          />
        </section>
      </section>
      <div class="text-group offset-left">
        <text-input
          id="customer_first_name"
          v-model="orderStore.customer_first_name"
          v-model:error="orderStore.errors.customer_first_name"
          show-valid
          label="Voornaam"
          placeholder=" "
        />
        <text-input
          id="customer_last_name"
          v-model="orderStore.customer_last_name"
          v-model:error="orderStore.errors.customer_last_name"
          show-valid
          label="Achternaam"
          placeholder=" "
        />
      </div>
      <date-input
        id="customer_birthdate"
        v-model="orderStore.customer_birthdate"
        v-model:error="orderStore.errors.customer_birthdate"
        label="Geboortedatum"
        placeholder=" "
      />

      <div class="contact-input">
      <text-input
          id="customer_email"
          v-model="orderStore.customer_email"
          v-model:error="orderStore.errors.customer_email"
          label="E-mailadres"
          inputmode="email"
          autocomplete="email"
          show-valid
        placeholder=" "
        />
      </div>
      <div class="contact-input">
        <text-input
          id="customer_phone"
          v-model="orderStore.customer_phone"
          v-model:error="orderStore.errors.customer_phone"
          label="Telefoonnummer"
          inputmode="tel"
          autocomplete="tel"
          show-valid
          placeholder=" "
        />
      </div>

      <div class="contact-input">
        <template
          v-for="confirmation in orderStore.product.confirmations"
          :key="confirmation.slug"
        >
        <template v-if="confirmation.position == 'contact'">
          <checkbox-input
            v-if="!confirmation.required"
            :id="confirmation.slug"
            v-model="orderStore.opt_ins[confirmation.slug]"
          >
            {{ confirmation.label }}
          </checkbox-input>

          <div v-if="confirmation.required" class="required-notice">
            {{ confirmation.label }}
          </div>
        </template>
        </template>
      </div>
    </template>
  </flow-part>
</template>

<script>
import BigRadioInput from '../../../../vue-elements/input/BigRadioInput.vue';
import DateInput from '../../../../vue-elements/input/DateInput.vue';
import TextInput from '../../../../vue-elements/input/TextInput.vue';
import CheckboxInput from '../../../../vue-elements/input/CheckboxInput.vue';
import FieldLabel from '../../../../vue-elements/field/FieldLabel.vue';
import FieldError from '../../../../vue-elements/field/FieldError.vue';
import FormPartMixin from '../../lib/FormPartMixin';
import FlowPart from '../FlowPart.vue';
import { useOrderStore } from '../../stores/orderStore';

export default {
    name: 'PersonalDataPart',
    components: {
        TextInput,
        DateInput,
        BigRadioInput,
        FlowPart,
        FieldLabel,
        FieldError,
        CheckboxInput
    },
    setup() {
        const orderStore = useOrderStore();
        return {
            orderStore,
        };
    },
    mixins: [FormPartMixin()],

};
</script>

<style scoped lang="scss">
@use '../../../../../assets/scss/_helpers/breakpoint';
@use '../../style/helpers';

.scroll-offset {
  scroll-margin: 64px;
}

.text-group {
  display: grid;
  grid-gap: 32px;
  width: 100%;

  // @include helpers.field-group-spacing;
  margin-bottom: 24px;

  @include breakpoint.up(md) {
    grid-gap: 16px;

    grid-template-columns: 1fr 1fr;
  }

  &.offset-right {
    @include breakpoint.up(md) {
      grid-template-columns: 1fr 0.75fr;
    }
  }

  &.offset-left {
    @include breakpoint.up(md) {
      grid-template-columns: 0.75fr 1fr;
    }
  }
}

.gender-field-group {
  margin-bottom: 24px;
}

.radio-group {
  display: grid;
  grid-gap: 12px;

  @include breakpoint.up(md) {
    grid-gap: 16px;
    grid-template-columns: repeat(3, 1fr);
  }
}

.contact-input {
  margin-top: 24px;
}

.required-notice {
  font-size: 15px;
  color: #3F7182;
  line-height: 1.4em;
}

.required-notice + .required-notice {
  margin-top: 8px;
}

</style>
